import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ChevronRight, Clock4Icon } from "lucide-react";
import CarIcon from "@/assets/icons/CarIcon.svg";
import { recentHistoryObject } from "@/central-atoms/everest-fleet-pwa/types";

type RecentHistoryTableProps = {
  data?: recentHistoryObject[] | [];
};

export function RecentHistoryTable({
  // data = [
  //   {
  //     tokenNumber: "TK001",
  //     dateTime: "14 June, 10:25AM",
  //   },
  //   {
  //     tokenNumber: "TK002",
  //     dateTime: "14 June, 11:00AM",
  //   },
  //   {
  //     tokenNumber: "TK003",
  //     dateTime: "14 June, 12:00PM",
  //   },
  //   {
  //     tokenNumber: "TK004",
  //     dateTime: "14 June, 01:00PM",
  //   },
  // ],
  data = [],
}: RecentHistoryTableProps) {
  return (
    <Table>
      <TableBody>
        {data.length === 0 ? (
          <TableRow>
            <TableCell colSpan={3} className="text-center text-white/60">
              No recent history available.
            </TableCell>
          </TableRow>
        ) : (
          data.map((recentHistory) => (
            <TableRow key={recentHistory.carNumber}>
              <TableCell className="font-medium text-primary">
                <div className="flex flex-row justify-between">
                  <img src={CarIcon} className="text-primary" />
                  {recentHistory.carNumber}
                </div>
              </TableCell>
              <TableCell className="text-white/60">
                <div className="flex flex-row justify-center gap-2">
                  <Clock4Icon />
                  {recentHistory.dateTime}
                </div>
              </TableCell>
              <TableCell>
                <Button
                  variant="icon"
                  size="icon"
                  className="rounded-full border-none bg-primary"
                >
                  <ChevronRight className="text-white" />
                </Button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
